import { createTheme } from "@mui/material/styles";
import InterWoff from "../assets/src/fonts/Inter-Regular.woff";
import InterWoff2 from "../assets/src/fonts/Inter-Regular.woff2";
import InterBoldWoff from "../assets/src/fonts/Inter-Bold.woff";
import InterBoldWoff2 from "../assets/src/fonts/Inter-Bold.woff2";
import { IThirdPartyStyles, LanguagesEnum } from "@monorepo/types";
import { LANGUAGE } from "../constants/language";

const perlasThirdPartyAttached = document?.getElementById("perlasgo-third-party-attached");
const isThirdParty = !!perlasThirdPartyAttached?.getAttribute("data-hostname")?.length;
const palette = perlasThirdPartyAttached?.getAttribute("data-palette");
const unparsedThirdPartyFontSizes = perlasThirdPartyAttached?.getAttribute("data-font-sizes");
let thirdPartyPalette: any;
let thirdPartyPaletteCopy: any;
let thirdPartyFontSizes: any;
//todo fix add interface later
if (isThirdParty) {
  if (!!palette && typeof palette === "string" && typeof JSON.parse(palette) === "object") {
    thirdPartyPalette = (JSON.parse(palette) as IThirdPartyStyles)?.palette;
    thirdPartyPaletteCopy = { ...thirdPartyPalette };
    if (thirdPartyPaletteCopy) {
      delete thirdPartyPaletteCopy.primary;
      delete thirdPartyPaletteCopy.secondary;
      delete thirdPartyPaletteCopy.white;
      delete thirdPartyPaletteCopy.neutral;
      delete thirdPartyPaletteCopy.card;
      delete thirdPartyPaletteCopy.error;
      delete thirdPartyPaletteCopy.text;
      delete thirdPartyPaletteCopy.background;
    }
  }
  if (
    !!unparsedThirdPartyFontSizes &&
    typeof unparsedThirdPartyFontSizes === "string" &&
    typeof JSON.parse(unparsedThirdPartyFontSizes) === "object"
  ) {
    thirdPartyFontSizes = (JSON.parse(unparsedThirdPartyFontSizes) as IThirdPartyStyles)?.fontSizes;
    if (
      !!thirdPartyFontSizes?.button &&
      !!Object.keys(thirdPartyFontSizes?.button)?.length &&
      !thirdPartyFontSizes?.button?.textTransform
    ) {
      thirdPartyFontSizes.button.textTransform = "none";
    }
  }
}
export const defaultFontFamily = "Inter";

const breakpointTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 767,
      md: 992,
      lg: 1200,
      xl: 1366,
      xxl: 1660,
    },
  },
});
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    neutral: true;
    white: true;
  }
}
declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    xxl: true;
  }
  interface Palette {
    white: Palette["primary"];
    black: Palette["primary"];
    azureishWhite: Palette["primary"];
    blueBayoux: Palette["primary"];
    nobelGray: Palette["primary"];
    geyserGray: Palette["primary"];
    shuttleGray: Palette["primary"];
    gullGray: Palette["primary"];
    crimson: Palette["primary"];
    error: Palette["primary"];
    mysticGray: Palette["primary"];
    neutral: Palette["primary"];
    success: Palette["primary"];
    warning: Palette["primary"];
    card: Palette["primary"];
  }
  interface PaletteOptions {
    white: PaletteOptions["primary"];
    black: PaletteOptions["primary"];
    azureishWhite: PaletteOptions["primary"];
    blueBayoux: PaletteOptions["primary"];
    nobelGray: PaletteOptions["primary"];
    geyserGray: PaletteOptions["primary"];
    shuttleGray: PaletteOptions["primary"];
    gullGray: PaletteOptions["primary"];
    crimson: PaletteOptions["primary"];
    neutral: PaletteOptions["primary"];
    mysticGray: PaletteOptions["primary"];
    card: PaletteOptions["primary"];
  }

  interface TypographyVariants {
    inputLabel: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    inputLabel?: React.CSSProperties;
  }
  interface PaletteColor {
    main: string;
  }
  interface SimplePaletteColorOptions {
    main: string;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    inputLabel: true;
  }
}

export const iconsSizes = {
  small: 20,
  medium: 25,
  large: 28,
  xLarge: 30,
};

export const spacingSizes = {
  xxSmall: "3px",
  xSmall: "6px",
  small: "12px",
  default: "18px",
  medium: "24px",
  large: "32px",
  xLarge: "48px",
  xxLarge: "72px",
};

export const colorsTheme = createTheme({
  palette: {
    primary: {
      main: "#32b88e", //main green color throughout whole app
      contrastText: "#fff", //contrastText is not used directly but necessary for text in primary btn
      dark: "#0B896D",
      light: "#40CFAF",
      ...(!!isThirdParty &&
        !!thirdPartyPalette?.primary && {
          ...thirdPartyPalette.primary,
        }),
    },
    secondary: {
      main: "#ffffff", //secondary white btn color
      contrastText: "#505f6a", //contrastText is not used directly but necessary for text in secondary btn
      dark: "#d5e3eb", //secondary white hover btn color
      light: "#ffffff", // not used directly
      ...(!!isThirdParty &&
        !!thirdPartyPalette?.secondary && {
          ...thirdPartyPalette.secondary,
        }),
    },
    white: {
      main: "#ffffff",
      contrastText: "#a1abb9",
      dark: "#d5e3eb", // not used directly
      light: "#ffffff", // not used directly
      ...(!!isThirdParty &&
        !!thirdPartyPalette?.white && {
          ...thirdPartyPalette.white,
        }),
    },
    neutral: {
      main: "#d5e3eb",
      contrastText: "#505f6a",
      ...(!!isThirdParty &&
        !!thirdPartyPalette?.neutral && {
          ...thirdPartyPalette.neutral,
        }),
    },
    card: {
      main: "#ffffff", //used for background when not active and icon stroke color when active
      light: "#d5e3eb", //used for card hover background
      dark: "#505f6a", //used for active card background,
      contrastText: "#ffffff", // text color when active
      ...(!!isThirdParty &&
        !!thirdPartyPalette?.card && {
          ...thirdPartyPalette.card,
        }),
    },
    azureishWhite: { main: "#d5e3eb" }, //used in dashboard toggle buttons, reg banner, button and etc
    background: {
      default: "#f2f6f9",
      paper: "#ffffff",
      ...(!!isThirdParty &&
        !!thirdPartyPalette?.background && {
          ...thirdPartyPalette?.background,
        }),
    }, //used mainly for background
    //blue
    blueBayoux: { main: "#4b6374" },
    error: {
      main: "#c74a4a", //toast error color or other errors color
      dark: "#dc143c", //used in error messages, history bar chart arrows
      ...(!!isThirdParty &&
        !!thirdPartyPalette?.error && {
          ...thirdPartyPalette?.error,
        }),
    },
    success: { main: "#32b88e" }, //toast succes color
    warning: { main: "#f1c40f" }, //toast warn color
    text: {
      primary: "#000000",
      secondary: "#505f6a",
      disabled: "#a1abb9",
      ...(!!isThirdParty &&
        !!thirdPartyPalette?.text && {
          ...thirdPartyPalette?.text,
        }),
    },
    //grey colors
    shuttleGray: { main: "#505f6a" }, //used in various places through web/3rd party
    gullGray: { main: "#a1abb9" }, //used in variuous places through web/3rd party
    mysticGray: { main: "#dfe5eb" }, //used in 2 places
    nobelGray: { main: "#b6b5b5" }, //used in various places through web/3rd party
    geyserGray: { main: "#dbe0e7" }, //used in several places through web/3rd party
    //black
    black: { main: "#000000" },
    ...(!!isThirdParty &&
      !!thirdPartyPaletteCopy && {
        ...thirdPartyPaletteCopy,
      }),
    ...(LANGUAGE === LanguagesEnum.PL && {
      primary: {
        main: "#1d2848", //main green color throughout whole app
        contrastText: "#fff", //contrastText is not used directly but necessary for text in primary btn,
        dark: "#6a6f83",
        light: "#6a6f83",
      },
      card: {
        main: "#ffffff", //used for background when not active and icon stroke color when active
        light: "#d5e3eb", //used for card hover background
        dark: "#1d2848", //used for active card background,
        contrastText: "#ffffff", // text color when active,
      },
    }),
  },
});

const reset = {
  width: "100%",
  overflowX: "hidden",
  overscrollBehaviorY: "none",
  height: "auto",
  [breakpointTheme.breakpoints.up("md")]: {
    height: "100vh",
    overflow: "hidden",
  },
};

export const componentsTheme = createTheme({
  components: {
    MuiButton: {
      variants: [],
      styleOverrides: {
        root: {
          minWidth: 170,
          borderRadius: 6,
          padding: "20px 15px",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "22px",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "@font-face": {
          fontFamily: `${defaultFontFamily}`,
          fontWeight: "normal",
          fontDisplay: "swap",
          src: `local('${defaultFontFamily}'), url('${InterWoff2}') format("woff2"), local('${defaultFontFamily}'),
      url('${InterWoff}') format("woff");`,
        },
        fallbacks: [
          {
            "@font-face": {
              fontFamily: `${defaultFontFamily}`,
              fontWeight: "normal",
              fontDisplay: "swap",
              src: `local('${defaultFontFamily}'), url('${InterWoff2}') format("woff2"), local('${defaultFontFamily}'),
          url('${InterWoff}') format("woff");`,
            },
          },
          {
            "@font-face": {
              fontFamily: `${defaultFontFamily}`,
              fontWeight: "bold",
              fontDisplay: "swap",
              src: `local('${defaultFontFamily}'), url('${InterBoldWoff2}') format("woff2"), local('${defaultFontFamily}'),
          url('${InterBoldWoff}') format("woff");`,
            },
          },
        ],
        "*, *::before, *::after": {
          boxSizing: "border-box !important",
          verticalAlign: "baseline",
          fontFamily: "inherit",
          fontStyle: "inherit",
          border: "none",
          padding: 0,
          margin: 0,
        },
        html: {
          ...reset,
          padding:
            "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)",
          "& .landscape": {
            background: colorsTheme.palette.background.default,
          },
        },
        body: {
          ...reset,
          position: "relative",
          lineHeight: 1.5,
          background: colorsTheme.palette.background.paper,
          "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
            width: 5,
            borderRadius: 10,
          },
          "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
            borderRadius: 10,
            minHeight: 24,
            backgroundColor: `${colorsTheme.palette.gullGray.main}`,
          },
          "&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track": {
            borderRadius: 10,
            backgroundColor: `${colorsTheme.palette.geyserGray.main}`,
          },
          "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
            backgroundColor: `${colorsTheme.palette.gullGray.main}`,
          },
          "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
            backgroundColor: `${colorsTheme.palette.gullGray.main}`,
          },
          "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
            backgroundColor: `${colorsTheme.palette.gullGray.main}`,
          },
        },
        "a, a:visited, input, input:visited": {
          outline: "none",
        },
        "input:hover, input:active, input:focus": {
          borderBottom: `1px solid ${colorsTheme.palette.primary.main}!important`,
        },
        select: {
          border: 0,
          borderBottom: `1px solid ${colorsTheme.palette.geyserGray.main}!important`,
          margin: 0,
          padding: `${spacingSizes.xSmall} ${spacingSizes.default} ${spacingSizes.xSmall} 0`,
          cursor: "pointer",
          boxSizing: "border-box",
          "&:active, &:focus": {
            borderBottom: `1px solid ${colorsTheme.palette.geyserGray.main}`,
          },
          "&:focus-visible": {
            outline: "none",
          },
        },
        ".MuiSvgIcon-colorSecondary": {
          color: `${colorsTheme.palette.gullGray.main}!important`,
        },
        ".MuiButton-containedSecondary": {
          "&.history, &.services, &.cart-list": {
            color: `${colorsTheme.palette.primary.main}!important`,
            "&.active svg path": {
              stroke: `${colorsTheme.palette.primary.main}!important`,
            },
          },
        },
      },
    },
  },
});

export const typographyTheme = createTheme({
  typography: {
    fontFamily: `${defaultFontFamily}, sans-serif`,
    fontSize: 14,
    htmlFontSize: 16,
    button: {
      textTransform: "none",
      fontSize: "1.25rem",
      ...(!!isThirdParty && {
        fontSize: "0.875rem",
      }),
    },
    fontWeightExtraBold: 800,
    fontWeightSemiBold: 600,
    subtitle1: {
      fontSize: "1.125rem",
    },
    inputLabel: {
      fontSize: "1.25rem",
      ...(!!isThirdParty && {
        fontSize: "1rem",
      }),
    },
    body2: {
      fontSize: "1rem",
    },
    h5: {
      fontSize: "2rem",
      lineHeight: 1.235,
      ...(!!isThirdParty && {
        fontSize: "1.5rem",
        lineHeight: 1.334,
        letterSpacing: "0em",
      }),
    },
    ...(!!isThirdParty &&
      !!thirdPartyFontSizes && {
        ...thirdPartyFontSizes,
      }),
  },
});

const theme = createTheme({
  typography: { ...typographyTheme.typography },
  breakpoints: { ...breakpointTheme.breakpoints },
  palette: { ...colorsTheme.palette },
  components: { ...componentsTheme.components },
});

export default theme;
